// Generated by CoffeeScript 2.7.0
export var SubscriptionsChannel = {
  connected: function() {
    return this.subscribe();
  },
  received: function(data) {
    return Push.create(data['title'], {
      body: data['body'],
      icon: {
        x16: '/assets/apple-touch-icon-40@2x.png',
        x32: '/assets/apple-touch-icon-76@2x.png'
      },
      timeout: 5000,
      link: data['link'],
      onClick: function() {
        return Turbolinks.visit(data['link']);
      }
    });
  },
  subscribe: function() {
    return this.perform('subscribed');
  }
};

export default SubscriptionsChannel;
